export const CreatePaylink = "create_paylinks";
export const MerchantProduct = "merchant_product";
export const MerchantCategory = "get_categories";
export const MerchantSetting = "merchant_settings";
export const MerchantAddress = "merchant_address";
export const MerchantOrders = "merchant_orders";
export const Ecommerce = "merchant-ecommerce";
export const MerchantEcommercePathway = "merchant-ecommerce-pathway"
export const MerchantPages = "merchant-pages";
export const GetSingleOrder = "get-single-order";
export const GetOrdersProducts = "merchant_orders_products_with";
export const Login = "user/login";
export const VerifyOTP = "user/verifyOtp";